/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["people-list-widget{display:block}people-list-widget .separator{padding-right:5px}people-list-widget a:hover{text-decoration:underline}"];
export { styles as styles };
